//按需加载iview ui 组件
import Vue from 'vue'
import { Row,Col ,Button,Form,FormItem,Select,Option,Input,DatePicker,Message,Notice,Collapse,Panel,Anchor,AnchorLink,Affix,Upload} from 'view-design'
Vue.component('Row', Row)
Vue.component('Col', Col)
Vue.component('Button', Button)
Vue.component('Form', Form)
Vue.component('FormItem', FormItem)
Vue.component('Select', Select)
Vue.component('Option', Option)
Vue.component('Input', Input)
Vue.component('DatePicker', DatePicker)
Vue.component('Collapse', Collapse)
Vue.component('Panel', Panel)
Vue.component('AnchorLink', AnchorLink)
Vue.component('Anchor', Anchor)
Vue.component('Affix', Affix)
Vue.component('Upload', Upload)

Vue.prototype.$Message = Message
Vue.prototype.$Notice = Notice
//message组件全局设置
Message.config({
    top: 300,
    duration: 2
});
Notice.config({
    top: 150,
    duration: 15
});
import 'view-design/dist/styles/iview.css'


